// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___fyEJk","root__button":"style-module__root__button___HQXvG","root__user":"style-module__root__user___OeMmj","root__admin":"style-module__root__admin___ocyWT","root__gallery":"style-module__root__gallery___W9Kzq","root__artist":"style-module__root__artist___La75F"};
    if(module.hot) {
      // 1744730406566
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  